export default function Footer() {
  return (
    <footer className="bg-white border-t border-[#e7e3cf] py-20 mt-20">
      <div className="max-w-[1440px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16">
          <div className="space-y-6">
            <div className="flex items-center gap-2">
              <div
                className="size-8 bg-primary rounded-lg flex items-center justify-center text-white"
              >
                <span className="material-symbols-outlined !text-sm font-bold"
                  >local_florist</span
                >
              </div>
              <h2 className="text-xl font-extrabold tracking-tight">
                Elysian<span className="text-primary">Hub</span>
              </h2>
            </div>
            <p className="text-sm text-[#9a8d4c] leading-relaxed">
              Connecting local flower sellers and event professionals with
              customers who cherish artisanal beauty and premium services in the
              Indian market.
            </p>
            <div className="flex gap-3">
              <a
                className="p-2.5 bg-[#f3f1e7] rounded-full hover:bg-primary hover:text-white transition-all"
                href="#"
                ><span className="material-symbols-outlined !text-lg"
                  >public</span
                ></a
              >
              <a
                className="p-2.5 bg-[#f3f1e7] rounded-full hover:bg-primary hover:text-white transition-all"
                href="#"
                ><span className="material-symbols-outlined !text-lg"
                  >thumb_up</span
                ></a
              >
              <a
                className="p-2.5 bg-[#f3f1e7] rounded-full hover:bg-primary hover:text-white transition-all"
                href="#"
                ><span className="material-symbols-outlined !text-lg"
                  >camera_alt</span
                ></a
              >
            </div>
          </div>
          <div>
            <h4
              className="font-black text-[#1b190d] mb-6 uppercase tracking-wider text-xs"
            >
              Categories
            </h4>
            <ul className="space-y-4 text-sm font-medium text-[#9a8d4c]">
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Daily Loose Flowers</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Wedding Garlands</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Flower Artisans</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Corporate Bulk</a
                >
              </li>
            </ul>
          </div>
          <div>
            <h4
              className="font-black text-[#1b190d] mb-6 uppercase tracking-wider text-xs"
            >
              Services
            </h4>
            <ul className="space-y-4 text-sm font-medium text-[#9a8d4c]">
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Professional Photography</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Wedding Planning</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Stage Decoration</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Vendor Registration</a
                >
              </li>
            </ul>
          </div>
          <div>
            <h4
              className="font-black text-[#1b190d] mb-6 uppercase tracking-wider text-xs"
            >
              Support
            </h4>
            <ul className="space-y-4 text-sm font-medium text-[#9a8d4c]">
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >How it Works</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Shipping Policy</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Privacy &amp; Terms</a
                >
              </li>
              <li>
                <a className="hover:text-primary transition-colors" href="#"
                  >Contact Us</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div
          className="mt-20 pt-8 border-t border-[#f3f1e7] flex flex-col md:flex-row justify-between items-center gap-4"
        >
          <p className="text-xs text-[#9a8d4c] font-medium">
            © 2024 ElysianHub Marketplace. All rights reserved.
          </p>
          <div className="flex gap-8">
            <img
              alt="Visa"
              className="h-6 grayscale opacity-50"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuDZxvvZLr2_Uu6gE6seX1_POBRg_gWzSSy9VA5zMvfwndE2qCxIrxpjFWNi0enoK0NXt2aZibmOjfvFoFBsc8QdVS2gJneThzX6QCqFb0_zKdil1yNt3yoSjT56nEk_QVVtOaYSQ6r__iil6POIX3pnG-Rd4du6PCKiKphADuOkMfK-CMr1_2RJjWOCMyVHA_xGKY_jxplqqZ0YEDtwJINkj2xsNXXFjEcu_9Bw2wTkIPk3DlZb3MtMWhakvIZgdQWYMM9JrrNjqkfB"
            />
            <img
              alt="Mastercard"
              className="h-6 grayscale opacity-50"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuCcSDjTiQRgBxg0tpb9qk0FywWT8NmrWlJBZu7P7Tj0sRn5Y60aW3krt67zuTzDVlsIktQM4pdp0yhVrj4D7iafdJhnl_OzHfgQn1D59hBXCvUAUg-6pk5MGr9klgIlElF1lcmUTh0djmL3rr_hyQueAssUG7-EH7L-UZn2-bCdrF-EhfTAJ3T2ZHyN8nsR6kZlxr7Wyi4i9mcznFpdbIyVN0Vy3L7RpaH6QYHyCzASj3yA2yX_YiVy8fXqjUXk4FsrMJR50EqklYBj"
            />
            <img
              alt="Paypal"
              className="h-6 grayscale opacity-50"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuCb5QgD0biWWJ24ff3Shkgm5xFiTy0yeEpqmmJclBXLytjM_55FamGlb3VNRerA19pap1vp778schEl0WgFvh_jWZ2cFpBFa7HxZGi6bi-RgVJ1DtqlUeFhN3TZibL6HlZdjhp93rIm-0wdgqhhoNXjtKartPsofeYS_li477SWfbjfnfdd4MpcjrJPQFDyrU2xZGc5POksEvaqohHNnw4gooqPOV2gg5XXTDVtrXtdmTIYNYIvOSgvf5tHYPHHbwdmvxqHrhHAOqFV"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
